import { slugify } from '@/utils/formatters/slugfy';

export const toCitySlug = (city?: string | null, state?: string | null): string | undefined =>
  city && state ? slugify(`${city}-${state}`) : undefined;
